import React from "react";
import { TableCellRenderer } from "react-table";

import { ITerminology } from "src/library/utils";
import { CustomTableColumn } from "src/library/components/Tables/Table";
import { Text } from "src/library/components/Text";
import { formatPrice } from "src/core/prices/utils/price-helpers";
import * as globalTableColumns from "src/core/shared/components/TableGlobalColumns";
import { TransactionType } from "src/modules/payment/api/transactions.api";

export interface TransactionTableProps {
  terminology: ITerminology;
  Button?: TableCellRenderer;
}

/**
 * Transaction table columns
 */
export const transactionTableColumns = (props: TransactionTableProps): CustomTableColumn[] => {
  const transactionColumn: CustomTableColumn[] = [
    globalTableColumns.id({
      header: "Transaction ID",
      width: 125,
      show: true
    }),
    globalTableColumns.transactionOrderId(),
    globalTableColumns.branch(props.terminology),
    globalTableColumns.transactionType(),
    globalTableColumns.transactionStatus(),
    globalTableColumns.date({
      format: "DD/MM/YYYY",
      header: "Billing date",
      accessor: "updatedAt"
    }),
    globalTableColumns.standardText({
      Header: "Amount",
      accessor: "amount",
      width: 100,
      Cell: row => (
        <Text>
          {`${row.original.type === TransactionType.CHARGE ? "-" : "+"} ${formatPrice(row.original.amount)}`}
        </Text>
      ),
      filterable: false
    }),
    globalTableColumns.actions({
      width: 150,
      cell: props.Button
    })
  ];

  return transactionColumn;
};
